import { postWithAuth } from '@/lib/httpAdapter';
import IsSlackConfiguredRequestType from '@/types/isSlackConfiguredRequestType';
import apiUrl from './api';
import headerObject from '@/types/headerObj';

const localHost = apiUrl;
const endPoint = 'isSlackConfigured/';
const url = localHost + endPoint;

const isSlackConfigured = async (
  req: IsSlackConfiguredRequestType,
  headerObj: headerObject
) => {
  try {
    const res = await postWithAuth(
      url,
      {
        OrgUUID: req.OrgUUID,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          ...headerObj,
        },
      }
    );

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

    const raw: unknown = await res.json();
    const data =
      typeof raw === 'string'
        ? (JSON.parse(raw) as Record<string, unknown>)
        : (raw as Record<string, unknown>);
    if (data.Error == null && data.Configured === true) {
      return true;
    }
    return false;
  } catch (err) {
    console.error(err);
  }
};

export default isSlackConfigured;
